import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import ProtectedWrapper from "../components/ProtectedWrapper";
import VolunteerContent from "./volunteerContent";

const Volunteer = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <ProtectedWrapper isLoggedIn={!!localStorage.getItem("token")}>
        <VolunteerContent />
      </ProtectedWrapper>

      <Footer />
    </>
  );
};

export default Volunteer;